export const TOGGLE_POST_LIKE = `
mutation togglePostLike($postId: ID!) {
  togglePostLike(postId: $postId) {
    liked
  }
}`;
